import axios from "axios";
import { getTenantSlug } from "@/lib/tenant";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

function readToken() {
  try { return localStorage.getItem("allure_token"); } catch (_) { return null; }
}

api.interceptors.request.use((config) => {
  const token = readToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Tenant scoping for public endpoints — when the app is mounted under
  // /s/:slug/... we always append `?studio=<slug>` so the URL is the
  // authoritative source of which tenant's data to render. We deliberately
  // do NOT skip this when an admin token is present: a logged-in tenant
  // visiting their own /s/<slug> URL must still see *that* slug's data,
  // not whatever studio happens to be in their JWT claim. The backend's
  // resolve_public_studio_id treats an explicit slug as the highest-priority
  // signal, so cross-tenant viewing (impersonation, support sessions) works
  // the way the URL suggests. See test_reports/iteration_view_site_link_fix.json.
  const slug = getTenantSlug();
  if (slug) {
    config.params = { ...(config.params || {}), studio: slug };
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
